// react
import React, { Component } from 'react';

// third-party
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// application
import Indicator from '../header/Indicator';
import {
    Menu18x14Svg,
    Search20Svg,
    Cart20Svg,
} from '../../svg';
import { mobileMenuOpen } from '../../store/mobile-menu';
import Search from '../header/Search';
import ProgramContext from '../../contexts/ProgramContext';

class MobileHeader extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchOpen: false,
        };
        this.searchInput = React.createRef();
    }

    componentDidUpdate(prevProps, prevState) {
        const { searchOpen } = this.state;

        if (searchOpen && searchOpen !== prevState.searchOpen && this.searchInput.current) {
            this.searchInput.current.focus();
        }
    }

    handleOpenSearch = () => {
        this.setState(() => ({ searchOpen: true }));
    };

    handleCloseSearch = () => {
        this.setState(() => ({ searchOpen: false }));
    };

    render() {
        const { openMobileMenu, cart } = this.props;
        const { searchOpen } = this.state;
        const searchClasses = classNames('mobile-header__search', {
            'mobile-header__search--open': searchOpen,
        });

        return (
            <div className="mobile-header">
                <div className="mobile-header__panel">
                    <div className="container">
                        <div className="mobile-header__body">
                            <button type="button" className="mobile-header__menu-button" onClick={openMobileMenu}>
                                <Menu18x14Svg />
                            </button>
                            <ProgramContext.Consumer>
                                {(context) => {
                                    let logo;
                                    const { program } = context;
                                    const { theme } = program;
                                    if (theme !== undefined) {
                                        logo = (
                                            <Link to="/" className="mobile-header__logo">
                                                <img width="auto" height="50px" alt="logo" src={theme.mobileLogo} />
                                            </Link>
                                        );
                                    }
                                    return logo;
                                }}
                            </ProgramContext.Consumer>
                            <Search
                                context="mobile-header"
                                className={searchClasses}
                                inputRef={this.searchInput}
                                onClose={this.handleCloseSearch}
                            />
                            <div className="mobile-header__indicators">
                                <Indicator
                                    className="indicator--mobile indicator--mobile-search d-md-none"
                                    onClick={this.handleOpenSearch}
                                    icon={<Search20Svg />}
                                />
                                <ProgramContext.Consumer>
                                    {(context) => {
                                        let plateau;
                                        const { program } = context;
                                        if (program && program.type === 'points') {
                                            plateau = (
                                                <Indicator
                                                    className="indicator--mobile"
                                                    url="/shop/cart"
                                                    value={cart.quantity}
                                                    icon={<Cart20Svg />}
                                                />
                                            );
                                        } else { plateau = (<span>{' '}</span>); }
                                        return plateau;
                                    }}
                                </ProgramContext.Consumer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    cart: state.cart,
    locale: state.locale,
});

const mapDispatchToProps = {
    openMobileMenu: mobileMenuOpen,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(MobileHeader);
